import { Box, Stack, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import { DocumentPreviewProps } from './DocumentPreview.interface';

import csvFileUploadedIcon from 'assets/img/icons/csv-file-uploaded-icon.svg';
import ArrowUpperRightIcon from 'modules/common/components/Icons/ArrowUpperRightIcon';
import useFetchReceiptMutation from 'modules/Tax/queries/useFetchReceiptMutation';

function DocumentPreview({ payment, onRemove }: DocumentPreviewProps) {
    // TODO: Change payment receipt payload to return filename and created_at

    const mutation = useFetchReceiptMutation();
    const { enqueueSnackbar } = useSnackbar();

    const onDownloadReceipt = (uuid: string) => {
        mutation.mutate(
            { uuid },
            {
                onSuccess: ({ url }) => {
                    window.open(url, '_blank', 'noopener,noreferrer');
                },
                onError: () => {
                    enqueueSnackbar('Failed to download payment receipt', { variant: 'error' });
                },
            }
        );
    };

    return (
        <Box borderRadius={4} bgcolor="grey.100" marginBottom={3} marginTop={1} padding={0.3} width="100%">
            <Box bgcolor="common.white" borderRadius={4} paddingX={5} paddingY={2}>
                <Stack direction="row" justifyContent="space-between">
                    <div>
                        <Stack direction="row" spacing={2}>
                            <Box alignSelf="center">
                                <img data-testid="upload-icon" src={csvFileUploadedIcon} alt="csv file uploaded icon" />
                            </Box>

                            <Stack>
                                <Stack alignItems="center" direction="row" spacing={0.5}>
                                    <Typography variant="body2">Payment Receipt</Typography>
                                    <ArrowUpperRightIcon
                                        data-testid="download"
                                        onClick={() => onDownloadReceipt(payment.payment_receipt as string)}
                                        sx={{ typography: 'body2', cursor: 'pointer' }}
                                    />
                                </Stack>

                                <Typography variant="caption">---</Typography>
                            </Stack>
                        </Stack>
                    </div>

                    <Box alignSelf="center" display="flex">
                        <CloseRoundedIcon data-testid="close" onClick={onRemove} sx={{ cursor: 'pointer' }} />
                    </Box>
                </Stack>
            </Box>
        </Box>
    );
}

export default DocumentPreview;
